export default __webpack_public_path__ + "static/resultaddonexample-0b446d6684003c3b1a3e028399b44195.png";